/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import Loading from '../../../components/loading/Loading';

export default function Cancel({
  openCancel,
  setOpenCancel,
  loadingCancel,
  handleCancel,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={() => setOpenCancel(false)}
      open={openCancel}
      fullWidth
      maxWidth="sm"
    >
      <Loading
        open={loadingCancel}
        msg={t('receivables.cancelDialog.loading')}
      />
      <DialogTitle id="simple-dialog-title">
        {t('receivables.cancelDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          style={{
            justifyContent: 'center',
          }}
        >
          <Grid item xs={12} sm={8}>
            <p
              style={{
                fontSize: '20px',
                textAlign: 'justify',
              }}
            >
              {`${t('receivables.cancelDialog.message')}`}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ height: 40 }}
          onClick={() => setOpenCancel(false)}
          variant="text"
          color="primary"
        >
          {t('receivables.createDialog.buttons.cancel')}
        </Button>
        <Button
          style={{ height: 40, backgroundColor: 'red', color: 'white' }}
          onClick={handleCancel}
          variant="contained"
          disabled={loadingCancel}
        >
          {t('receivables.cancelDialog.buttons.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
